import MultipleChoice from 'modules/core/components/Filter/filters/MultipleChoice'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'
import { useUnsafeEffect } from '@factorialco/deprecated-design-system'
import { LegacyJobCatalogFeatureEnabledDocument } from 'generated/resources/graphql'

import { useJobCatalogRoleOptions } from 'modules/job_catalog/lib/filters/jobRole'

interface Props {
  defaultValue?: string[]
  selectedValue?: string[]
  defaultOpen?: boolean
  onChange: (value?: string[]) => void
}

export const JobRoleSelector = ({ defaultValue, selectedValue, defaultOpen, onChange }: Props) => {
  const {
    company: { id: companyId },
  } = useCurrentSession()

  const { data: legacyJobCatalogFeatureEnabledData } = useQuery(
    LegacyJobCatalogFeatureEnabledDocument,
    {
      fetchPolicy: 'network-only',
      variables: { companyId },
    }
  )

  const hasLegacyJobCatalog =
    !!legacyJobCatalogFeatureEnabledData?.features?.featuresConnection?.totalCount
  const hasJobCatalogTreeFeature = !hasLegacyJobCatalog
  const options = useJobCatalogRoleOptions({ hasJobCatalogTreeFeature })

  const handleOnChange = (value?: string[]) => {
    onChange(value?.filter((id) => options.some((option) => option.value === id)))
  }

  const selectedValues = selectedValue?.filter((selectedId) =>
    options.some((option) => option.value === selectedId)
  )

  useUnsafeEffect(() => {
    if (defaultValue?.length && !selectedValue?.length && options.length) {
      handleOnChange(defaultValue)
    }
  }, [defaultValue, handleOnChange, options, selectedValue])

  return (
    <MultipleChoice
      value={selectedValues}
      options={options}
      defaultOpen={defaultOpen}
      onValueChange={handleOnChange}
      composeActiveLabel={(selected) => `(${selected.length})`}
      label={i18n.t('employees.employees_list.filters.job_role')}
    />
  )
}
